import React from 'react'
import { Link } from 'react-router-dom'
import './navbar.css'
import Loader from '../login_logout/loader'



const Navbar = () => {


    return (
        <>
            <header className="container-navbar">

                <Link to="/">
                    <h1 className="logo">Analyti<span className="blue">.ca</span></h1>

                </Link>


                <ul className="nav">

                    <Link to="/dashboard">
                        <li className="nav-item">Dashboard</li>
                    </Link>

                </ul>

            </header>
        </>
    )

}

export default Navbar